import React, { useId } from 'react';

const UpcessLogoIcon = ({ width = 40, height = 40, className = "" }) => {
  // Generates a unique ID for this specific instance (e.g., ":r0:", ":r1:")
  const id = useId();

  // Create unique references for each gradient
  const g1Id = `g1-${id}`;
  const g2Id = `g2-${id}`;

  return (
    <svg 
      version="1.2" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 788 788" 
      width={width} 
      height={height} 
      className={className}
    >
      <defs>
        <linearGradient id={g1Id} x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(240.552,796.162,-946.017,285.829,49.018,55.498)">
          <stop offset="0" stopColor="#8f59f7"/>
          <stop offset="1" stopColor="#01b9d3"/>
        </linearGradient>
        <linearGradient id={g2Id} x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(240.553,796.162,-393.519,118.898,49.019,55.498)">
          <stop offset="0" stopColor="#8f59f7"/>
          <stop offset="1" stopColor="#01b9d3"/>
        </linearGradient>
      </defs>
      <path 
        fill={`url(#${g1Id})`} 
        d="m473.61 250.19c8.99-204.11 229.94-255.21 259.85-242.35 15.6 6.72 5.88 418.03 5.02 454.37-8.56 362.17-525.11 433.51-660.66 125.66 6.73 0.21 82.57 99.24 194.24 89.32 256.54-22.79 195.1-280.34 201.55-427z"
      />
      <path 
        fill={`url(#${g2Id})`} 
        d="m50.57 21.8c1.51-45.78 255.72 15.23 264.83 228.39 1.1 25.8-0.86 255.52 2.31 271.38 3.47 17.29 32.65 24.5 36.08 25.35 114.05-6.55-165.02 148.82-281.95-68.82-17.29-32.19-34.23-63.71-21.27-456.3z"
      />
    </svg>
  );
};

export default UpcessLogoIcon;